import { Mapper } from "../../../../base/utils/mapper";
import { UserTourModel } from "../../../../domain/models/user/user-tour.model";
import { UserTourEntity } from "../entities/user-tour.entity";



export class UserTourImplementationRepositoryMapper extends Mapper<UserTourEntity, UserTourModel> {
    mapFrom(param: UserTourEntity): UserTourModel {
        return {
            data:param.data,
            isSuccess: param.isSuccess,
            message: param.message,
            errors:param.errors
        };
    }
    mapTo(param: UserTourModel): UserTourEntity {
        return {
            data:param.data,
            isSuccess: param.isSuccess,
            message: param.message,
            errors:param.errors
        }
    }
}